import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/height-weight-ratio-calculator',
  component: () => import('../../routes/HeightWeightRatioCalculator.svelte'),
  card: {
    id: 'height-weight-ratio-calculator',
    title: 'Height & Weight Ratio',
    description: 'Calculate your BMI and Ponderal Index using the standard height and weight ratio formulas. Supports both imperial (ft/in, lbs) and metric (cm, kg) units.',
    icon: 'straighten',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/height-weight-ratio-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Height & Weight Ratio Calculator – BMI & Ponderal Index',
    description: 'Free height and weight ratio calculator. Calculate your BMI (Body Mass Index) and Ponderal Index from your height and weight. Supports imperial and metric units.',
  },
};

export default meta;
